import { Component, Input, OnInit } from "@angular/core";
import { TimeScanningService } from "../../shared/data.service";

@Component({
	selector: "caass-scan-point-manual-attendance",
	templateUrl: "./scan-point-manual-attendance.component.html",
	styleUrls: ["./scan-point-manual-attendance.component.css"],
})
export class ScanPointManualAttendanceComponent implements OnInit {
	constructor(private scanService: TimeScanningService) {}

	ngOnInit(): void {
		this.loadAttendanceData();
	}

	/////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////
	AudienceMode: any = "Student";
	@Input() FacilityID: any;
	@Input() SelectedPerson: any;

	lstAttendance: any = [];
	SelectedEntry: any = null;
	cols: any = [
		{ field: "AttendanceDateStr", header: "Date" },
		{ field: "AttendanceTimeStr", header: "Time" },
		{ field: "AttendanceStatusDesc", header: "Status" },
	];
	pagefirst: Number = 0;
	pagerows: Number = 5;
	//////////////////////////////////////////

	//////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////
	loadAttendanceData() {
		if (this.SelectedPerson == null || this.SelectedPerson.PersonID <= 0) {
			return;
		}

		var result = this.scanService.RecentAttendanceGetList("", this.SelectedPerson.PersonID);
		result.subscribe(
			(response) => {
				this.lstAttendance = response;
			},
			(error) => {}
		);
	}
	//////////////////////////////////////////

	//////////////////////////////////////////
	// Events
	//////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}
	//////////////////////////////////////////
}
